<div class="fm-authentication">
  <div class="container-fluid fm-container-full">
    <div class="row h-100">

      <!-- Cover Image -->
      <div class="col-lg-6 p-0 position-relative d-none d-lg-block">
        <div class="fm-cover-image">
          <img src="images/signin/fm-signin-bg.png" alt="Cover" class="img-fluid" />
        </div>
      </div>

      <!-- Auth Card -->
      <div class="col-lg-6">
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col-sm-11">
            <div class="fm-auth-card">

              <!-- Logo -->
              <div class="fm-auth-chead">
                <div class="fm-logo">
                  <a routerLink="/"><img src="images/logo.svg" width="213" alt="Forever Memories" /></a>
                </div>
              </div>

              <!-- ── VERIFYING ── -->
              @if (pageState() === 'verifying') {
                <div class="fm-invitation-state text-center py-4">
                  <div class="fm-inv-icon-wrap fm-inv-icon-verifying mb-3">
                    <div class="fm-inv-spinner"></div>
                  </div>
                  <h3 class="fm-head-28 fm-head-sty2 fw-bold mb-2">Verifying Invitation</h3>
                  <p class="mb-0">Please wait while we validate your invitation link…</p>
                </div>
              }

              <!-- ── ERROR ── -->
              @if (pageState() === 'error') {
                <div class="fm-invitation-state text-center py-4">
                  <div class="fm-inv-icon-wrap fm-inv-icon-error mb-3">
                    <img src="images/icons/fm-logout.svg" class="fm-svg fm-inv-state-icon" alt="Error" />
                  </div>
                  <h3 class="fm-head-28 fm-head-sty2 fw-bold mb-2">Oops!</h3>
                  <p class="fm-inv-error-msg mb-3">{{ errorMessage() }}</p>
                  <p class="text-muted small mb-0">Redirecting to login in 3 seconds…</p>
                  <a routerLink="/login" class="fm-common-btn mt-4 d-inline-flex">Go to Login</a>
                </div>
              }

              <!-- ── SUCCESS ── -->
              @if (pageState() === 'success') {
                <div class="fm-invitation-state text-center py-4">
                  <div class="fm-inv-icon-wrap fm-inv-icon-success mb-3">
                    <img src="images/icons/fm-check.svg" class="fm-svg fm-inv-state-icon" alt="Success" />
                  </div>
                  <h3 class="fm-head-28 fm-head-sty2 fw-bold mb-2">You're all set!</h3>
                  <p class="mb-3">Your password has been created successfully. Welcome to Forever Memories!</p>
                  <p class="text-muted small mb-0">Redirecting to login in 3 seconds…</p>
                  <a routerLink="/login" class="fm-common-btn mt-4 d-inline-flex">Go to Login</a>
                </div>
              }

              <!-- ── READY: Set Password Form ── -->
              @if (pageState() === 'ready') {
                <div class="fm-auth-chead mt-0 pt-0">
                  <h3 class="fm-head-28 fm-head-sty2 fw-title fw-bold">Join Your Family Space</h3>
                  <p>Set your password to start capturing and preserving your memories.</p>
                </div>

                <div class="fm-signin-form">
                  <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
                    <fieldset class="row g-3 g-sm-4">

                      <!-- Email (readonly) -->
                      <div class="col-12">
                        <div class="form-group">
                          <label class="fm-label">Email Address</label>
                          <input type="email" class="form-control fm-readonly-field"
                                 [value]="email()" readonly tabindex="-1" />
                        </div>
                      </div>

                      <!-- New Password -->
                      <div class="col-12">
                        <div class="form-group">
                          <label class="fm-label">Password</label>
                          <div class="fm-input-group">
                            <input [type]="showPassword() ? 'text' : 'password'"
                                   class="form-control"
                                   [class.is-invalid]="f['newPassword'].invalid && f['newPassword'].touched"
                                   formControlName="newPassword"
                                   placeholder="Enter Your Password" />
                            <button type="button" class="fm-password-eye" (click)="togglePassword()">
                              <i [class]="showPassword() ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                            </button>
                          </div>
                          @if (f['newPassword'].errors?.['required'] && f['newPassword'].touched) {
                            <div class="fm-error-msg">Password is required.</div>
                          } @else if (f['newPassword'].errors?.['minlength'] && f['newPassword'].touched) {
                            <div class="fm-error-msg">Password must be at least 8 characters.</div>
                          } @else if (f['newPassword'].errors?.['maxlength'] && f['newPassword'].touched) {
                            <div class="fm-error-msg">Password must be at most 12 characters.</div>
                          } @else if (f['newPassword'].errors?.['pattern'] && f['newPassword'].touched) {
                            <div class="fm-error-msg">Must include uppercase, number &amp; special character.</div>
                          }
                          <!-- Password strength hints -->
                          @if (f['newPassword'].dirty || f['newPassword'].touched) {
                            <div class="fm-pw-hints">
                              <div class="fm-pw-hint" [class.met]="passwordCriteria.minLength">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                At least 8 characters
                              </div>
                              <div class="fm-pw-hint" [class.met]="passwordCriteria.maxLength">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                Max 12 characters
                              </div>
                              <div class="fm-pw-hint" [class.met]="passwordCriteria.hasUpper">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                1 uppercase letter
                              </div>
                              <div class="fm-pw-hint" [class.met]="passwordCriteria.hasNumber">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                1 number
                              </div>
                              <div class="fm-pw-hint" [class.met]="passwordCriteria.hasSpecial">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                1 special character (@$!%*?&amp;)
                              </div>
                            </div>
                          }
                        </div>
                      </div>

                      <!-- Confirm Password -->
                      <div class="col-12">
                        <div class="form-group">
                          <label class="fm-label">Confirm Password</label>
                          <div class="fm-input-group">
                            <input [type]="showConfirmPassword() ? 'text' : 'password'"
                                   class="form-control"
                                   [class.is-invalid]="(f['confirmPassword'].invalid && f['confirmPassword'].touched) || passwordMismatch"
                                   formControlName="confirmPassword"
                                   placeholder="Re-Enter Password" />
                            <button type="button" class="fm-password-eye" (click)="toggleConfirmPassword()">
                              <i [class]="showConfirmPassword() ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
                            </button>
                          </div>
                          @if (passwordMismatch) {
                            <div class="fm-error-msg">Passwords do not match.</div>
                          }
                        </div>
                      </div>

                      <!-- API Error Message -->
                      @if (submitError()) {
                        <div class="col-12">
                          <div class="fm-error-msg d-flex align-items-center gap-2">
                            <i class="bi bi-exclamation-circle-fill"></i>
                            {{ submitError() }}
                          </div>
                        </div>
                      }

                      <!-- Submit -->
                      <div class="col-12">
                        <button class="fm-common-btn w-100 mt-2 mt-lg-3" type="submit" [disabled]="isSubmitting()">
                          @if (isSubmitting()) {
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Creating Account…
                          } @else {
                            Create Account
                          }
                        </button>
                      </div>

                    </fieldset>
                  </form>
                </div>
              }

            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
